/**
 * Created by AlexanderC on 5/27/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Action = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Extractable2 = require('./Extractable');

var _Service = require('../Service');

var _InvalidArgumentException = require('../../Exception/InvalidArgumentException');

var _Policy = require('./Policy');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Iam statement action
 */
let Action = exports.Action = function (_Extractable) {
  _inherits(Action, _Extractable);

  /**
   * @param {String} service
   * @param {String} actionName
   */
  function Action() {
    let service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Service.Service.ANY;
    let actionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Policy.Policy.ANY;

    _classCallCheck(this, Action);

    var _this = _possibleConstructorReturn(this, (Action.__proto__ || Object.getPrototypeOf(Action)).call(this));

    _this._service = null;
    _this._action = actionName;

    _this.service = service;
    return _this;
  }

  /**
   * @param {String} action
   */


  _createClass(Action, [{
    key: 'extract',


    /**
     * @returns {String}
     */
    value: function extract() {
      let service = this._service;
      let action = this._action;

      return `${service}:${action}`;
    }
  }, {
    key: 'action',
    set: function set(action) {
      this._action = action;
    }

    /**
     * @returns {String}
     */
    ,
    get: function get() {
      return this._action;
    }

    /**
     * @param {String} name
     */

  }, {
    key: 'service',
    set: function set(name) {
      if (!_Service.Service.exists(name)) {
        throw new _InvalidArgumentException.InvalidArgumentException(name, _Service.Service);
      }

      this._service = name;
    }

    /**
     * @returns {String}
     */
    ,
    get: function get() {
      return this._service;
    }
  }]);

  return Action;
}(_Extractable2.Extractable);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/IAM/Action.js
// module id = 161
// module chunks = 0